import { HTMLExtUtils } from '@ssml-editor/core';
import { SUB_TYPE } from './constant.js';

const subHtmlToElement = ({
  element,
  children
}) => {
  const mark = HTMLExtUtils.getDataAttribute(element, "mark", "");
  const alias = HTMLExtUtils.getDataAttribute(element, "alias", "");
  return {
    type: SUB_TYPE,
    mark,
    alias,
    children
  };
};

export { subHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
